/**
 * Medida del modal de la ONU de SmartOLT. El splitter y el LIVE de tráfico (y otra ONU abierta desde
 * el splitter) usan la misma, ancho y alto, para no verse uno encima del otro.
 */
export const ONU_DIALOG_WIDTH = '1280px';
/** el alto máximo de los diálogos de PrimeNG: el modal de la ONU siempre lo alcanza */
export const ONU_DIALOG_HEIGHT = '90vh';
export const ONU_DIALOG_BREAKPOINTS = { '1360px': '95vw', '640px': '98vw' };
/** estilo de los p-dialog del modal: mismo ancho y alto, nunca más ancho que la pantalla */
export const ONU_DIALOG_STYLE = {
  width: ONU_DIALOG_WIDTH,
  height: ONU_DIALOG_HEIGHT,
  maxWidth: '98vw',
};
